const ButtonSize = {
  SMALLER: "SMALLER",
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
};

export default ButtonSize;
